module.exports = __webpack_public_path__ + "img/light-moon.b4cbcdfe.svg";